const FB_PIXEL_ID = process.env.REACT_APP_FB_PIXEL_ID;

class FacebookPixel {
  constructor() {
    this.initialized = false;
    this.pixelId = FB_PIXEL_ID;
  }

  init() {
    if (this.initialized || !this.pixelId) return;

    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod
          ? n.callMethod.apply(n, arguments)
          : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(
      window,
      document,
      "script",
      "https://connect.facebook.net/en_US/fbevents.js"
    );

    window.fbq("init", this.pixelId);
    this.initialized = true;
  }

  track(eventName, parameters = {}) {
    if (!this.initialized) return;

    const standardEvents = [
      "AddPaymentInfo",
      "AddToCart",
      "AddToWishlist",
      "CompleteRegistration",
      "Contact",
      "CustomizeProduct",
      "Donate",
      "FindLocation",
      "InitiateCheckout",
      "Lead",
      "Purchase",
      "Schedule",
      "Search",
      "StartTrial",
      "SubmitApplication",
      "Subscribe",
      "ViewContent"
    ];

    if (standardEvents.includes(eventName)) {
      window.fbq("track", eventName, parameters);
    } else {
      window.fbq("trackCustom", eventName, parameters);
    }
  }

  page() {
    if (!this.initialized) return;
    window.fbq("track", "PageView");
  }

  identify(userId, traits = {}) {
    if (!this.initialized) return;

    const userInfo = {};

    if (traits.email) userInfo.em = traits.email;
    if (traits.firstName || traits.firstname)
      userInfo.fn = traits.firstName || traits.firstname;
    if (traits.lastName || traits.lastname)
      userInfo.ln = traits.lastName || traits.lastname;
    if (traits.phone) userInfo.ph = traits.phone;
    if (traits.city) userInfo.ct = traits.city;
    if (traits.state) userInfo.st = traits.state;
    if (traits.postal_code || traits.postalCode)
      userInfo.zp = traits.postal_code || traits.postalCode;
    if (traits.country) userInfo.country = traits.country;

    if (userId) userInfo.external_id = userId;

    window.fbq("init", this.pixelId, userInfo);
  }
}

export default new FacebookPixel();
